import { hasNonEmptyString } from './parseHelpers';

export function validateRequiredString(value: string, label: string, errors: Array<string>) {
  if (!hasNonEmptyString(value)) {
    errors.push(`${label} is required`);
  }
}
